var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "space",
      staticClass: "c2-space",
      class: {
        "c2-space-horizontal": _vm.direction === "horizontal",
        "c2-space-vertical": _vm.direction === "vertical"
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }